<ion-searchbar
  type="text"
  [(ngModel)]="autocompleteInput"
  placeholder="Search for area, street name..."
  #addresstext
>
</ion-searchbar>
